import LegalPageLayout from '../../components/LegalPageLayout'

export default function DataDeletion() {
  return (
    <LegalPageLayout title="Data Deletion Request" lastUpdated="March 1, 2026">
      <div className="space-y-6">

        <section>
          <p className="text-gray-700 mb-4">
            At LoanLoop, you have the right to request deletion of your personal data at any time.
            This page explains what data we hold and how to request its removal.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">What Data We Store</h2>
          <p className="text-gray-700 mb-4">
            If you signed in using a social login provider (Facebook, Google, Apple, or Microsoft),
            we store the following information in your LoanLoop account:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Your name (first and last)</li>
            <li>Your email address</li>
            <li>Your social provider user ID (used to link your account — no passwords are stored)</li>
            <li>Any profile information you manually provided (phone number, address, loan preferences)</li>
            <li>Loan comparison searches you have saved</li>
          </ul>
          <p className="text-gray-700 mt-4">
            We do not store your social media password, friends list, posts, or any payment information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">How to Request Data Deletion</h2>
          <p className="text-gray-700 mb-4">
            To request deletion of all personal data associated with your LoanLoop account:
          </p>
          <ol className="list-decimal pl-6 text-gray-700 space-y-3">
            <li>
              Send an email to <strong>privacy@loanloop.com.au</strong> with the subject line:
              <span className="font-mono bg-gray-100 px-2 py-1 rounded ml-1">Data Deletion Request</span>
            </li>
            <li>
              Include the email address associated with your LoanLoop account so we can identify your records.
            </li>
            <li>
              We will confirm receipt within <strong>2 business days</strong> and complete the deletion
              within <strong>30 days</strong> in accordance with the Australian Privacy Act 1988.
            </li>
          </ol>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">What Happens After Deletion</h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Your LoanLoop account and all associated profile data will be permanently deleted.</li>
            <li>Your social login connection (Facebook, Google, etc.) will be disconnected from LoanLoop.</li>
            <li>
              Certain records may be retained for the minimum period required by Australian law
              (e.g. financial transaction records).
            </li>
            <li>Deletion is irreversible — you will need to create a new account to use LoanLoop again.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Disconnecting Facebook from LoanLoop</h2>
          <p className="text-gray-700 mb-4">
            You can also remove LoanLoop's access to your Facebook account directly through Facebook:
          </p>
          <ol className="list-decimal pl-6 text-gray-700 space-y-2">
            <li>Go to <strong>Facebook Settings</strong> → <strong>Security and Login</strong> → <strong>Apps and Websites</strong>.</li>
            <li>Find <strong>LoanLoop</strong> and click <strong>Remove</strong>.</li>
            <li>To also delete your LoanLoop account data, follow the email process above.</li>
          </ol>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
          <div className="mt-4 p-4 bg-gray-50 rounded-md">
            <p className="text-gray-700"><strong>Email:</strong> privacy@loanloop.com.au</p>
            <p className="text-gray-700 mt-1"><strong>Subject:</strong> Data Deletion Request</p>
          </div>
          <p className="text-gray-700 mt-4">
            If you are not satisfied with our response, you may lodge a complaint with the
            Office of the Australian Information Commissioner (OAIC) at{' '}
            <a href="https://www.oaic.gov.au" className="text-primary-600 hover:text-primary-700">
              www.oaic.gov.au
            </a>.
          </p>
        </section>

      </div>
    </LegalPageLayout>
  )
}
